import isValidEmailUtil from './isValidEmail';
import isValidPhoneUtil from './isValidPhone';

/**
 * Centralized validation functions for react-hook-form.
 * Each function should return true if valid, or an error message string if invalid.
 */

/**
 * Validates an email address.
 * @param {string} value - The email value to validate.
 * @param {object} [options] - Optional configuration.
 * @param {string} [options.errorMessage] - Custom error message to return on failure.
 * @returns {boolean|string} - True if valid, error message string otherwise.
 */
export const validateEmail = (value, options) => {
  const defaultMessage = 'Please enter a valid email address.';
  return isValidEmailUtil(value) || (options?.errorMessage || defaultMessage);
};

/**
 * Validates a phone number.
 * @param {string} value - The phone number value to validate.
 * @param {object} [options] - Optional configuration.
 * @param {string} [options.errorMessage] - Custom error message to return on failure.
 * @returns {boolean|string} - True if valid, error message string otherwise.
 */
export const validatePhone = (value, options) => {
  const defaultMessage = 'Please enter a valid phone number.';
  return isValidPhoneUtil(value) || (options?.errorMessage || defaultMessage);
};

// Add more validation functions here as needed
// e.g., validateRequired, validateMinLength, etc.

/**
 * Helper to get validation functions with context (like error messages)
 * This can be used in PurchaseFormProvider to prepare functions for context
 */
export const getValidationFunctions = (config = {}) => ({
  validateEmail: (value) => validateEmail(value, { errorMessage: config.invalidEmailMessage }),
  validatePhone: (value) => validatePhone(value, { errorMessage: config.invalidPhoneMessage }),
  // Add other configured validators here
});
